import React from 'react'
import Base from './Base'

export default props => (
  <Base {...props}>
    <path d='M3.39,29h3.7V44.06a1.69,1.69,0,0,0,1.66,1.66h11.1a.77.77,0,0,0,.51-.13V31.68h9.18v14H40.39a1.7,1.7,0,0,0,1.66-1.66V29h4.59a1.66,1.66,0,0,0,1.15-2.8L26.61,4.76a1.62,1.62,0,0,0-2.3,0L2.24,26.2A1.64,1.64,0,0,0,3.39,29Z' />
  </Base>
)
